module.exports = __webpack_public_path__ + "static/media/best-price.db93d7e7.png";